/* LauVéA – masque le bouton « Prévenez-moi » (Stoq) quand la variante est disponible */
(function () {
  var RE = /pr[ée]venez-moi/i, hidden = [], timer;
  function mainBtn() {
    return document.querySelector('.product__info-container .product-form__submit') || document.querySelector('.product-form__submit');
  }
  function climb(el) {
    var t = (el.textContent || '').trim(), n = 0;
    while (n < 3 && el.parentElement && el.parentElement !== document.body && !el.parentElement.matches('form,main,section,.product__info-container,.product__info-wrapper')) {
      if ((el.parentElement.textContent || '').trim() !== t) break;
      el = el.parentElement; n++;
    }
    return el;
  }
  function run() {
    var btn = mainBtn();
    if (!btn) return;
    var ok = !btn.disabled;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), node, found = [];
    while ((node = w.nextNode())) {
      if (!RE.test(node.nodeValue) || !node.parentElement) continue;
      if (node.parentElement.closest('script,style,#lv-orbite')) continue;
      found.push(climb(node.parentElement));
    }
    found.forEach(function (el) { if (hidden.indexOf(el) < 0) hidden.push(el); });
    hidden.forEach(function (el) { el.style.display = ok ? 'none' : ''; });
  }
  function later() { clearTimeout(timer); timer = setTimeout(run, 150); }
  function start() {
    run();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', later);
    setInterval(run, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();